import React from 'react';
import CalculatorAssumptions from './CalculatorAssumptions';

class MinimalCalculatorLayout extends React.Component {
  render() {
    return (
      <div className="minimal-calculator-layout">
        {this.props.formColumn}
      </div>
    )
  }
}

export default MinimalCalculatorLayout;

